import { useEffect, useState } from "react";
import Axios from "../utils/axiosInstance";
import { useParams } from "react-router-dom";

function useDisplaySearchData(apiFilters) {
  const { searchString } = useParams();
  const [data, setData] = useState();
  const [errors, setErrors] = useState(null);
  useEffect(() => {
    const displayDetails = async () => {
      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_API_BASE_URL}collection/search?q=${searchString}&filters=${apiFilters}`
        );
        setData(response);
      } catch (err) {
        setErrors(err);
      }
    };
    displayDetails();
  }, [searchString, apiFilters]);
  return { data };
}

export default useDisplaySearchData;
